import { Directive, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from './value-accessor-base';

@Directive({
    standalone: false,
    selector: 'input[mas-number-nl][ngModel]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumberNlDirective),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NumberNlDirective),
            multi: true
        }
    ]
})
export class NumberNlDirective extends ValueAccessorBase<number> {
    private _validateRegExp: RegExp;
    private _allowRegExp: RegExp;
    private _numberFormat: Intl.NumberFormat;

    @Input('mas-number-nl') set style(value: string) {
        switch (value) {
            case 'integer':
                this._validateRegExp = new RegExp('^-?\[0-9]+(\.\[0-9]+)?$');
                this._allowRegExp = new RegExp('[0-9\+\.\-]');
                this._numberFormat = new Intl.NumberFormat(['nl-NL'], {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });
                break;
            default:
                this._validateRegExp = new RegExp('^-?\[0-9]+(\.\[0-9]+)*(,\[0-9]+)?$');
                this._allowRegExp = new RegExp('[0-9,\+\.\-]');
                this._numberFormat = new Intl.NumberFormat(['nl-NL'], {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                break;
        }
    }

    @Input('mas-number-maxvalue')
    maxvalue?: number;

    @Input('mas-number-minvalue')
    minvalue?: number;

    constructor(renderer: Renderer2, elementRef: ElementRef) {
        super(renderer, elementRef);
        this._validateRegExp = new RegExp('^-?\[0-9]+(\.\[0-9]+)*(,\[0-9]+)?$');
        this._allowRegExp = new RegExp('[0-9,\+\.\-]');
        this._numberFormat = new Intl.NumberFormat(['nl-NL'], {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        this.style = 'decimal';
    }

    protected format(n: number): string {
        return n === null || n === undefined ? '' : this._numberFormat.format(n);
    }

    protected isValidChar(c: string): boolean {
        return this._allowRegExp.test(c);
    }

    protected parse(value: string): { parsed: number | undefined, errors: any } {
        if (value === undefined || value === null || value === '') {
            return { parsed: undefined, errors: undefined };
        }
        if (this._validateRegExp.test(value)) {
            let text = value.replace('\.', '');
            text = text.replace(',', '.');
            const parsedValue: number = +text;
            if (!Number.isNaN(parsedValue)) {
                if (this.maxvalue) {
                    if (parsedValue > this.maxvalue) {
                        return {
                            parsed: parsedValue, errors: { 'tooLargeValue': { value } }
                        };
                    }
                }
                if (this.minvalue) {
                    if (parsedValue < this.minvalue) {
                        return {
                            parsed: parsedValue, errors: { 'tooSmallValue': { value } }
                        };
                    }
                }
              return { parsed: parsedValue, errors: null };
            }
        }
        return { parsed: undefined, errors: { 'invalidNumber': { value } } };
    }
}
